export { default } from "./CurricInfoCard";
